// qrcreate_dashboard.jsx — QR Create operator admin dashboard layout.
// Owns the active tab and renders the matching manager under the header.
//
// The users tab can be deep-linked into from the other tabs (a code or a scan
// row opens its owner), so the selected user id lives here rather than inside
// UsersManager — that is the only state two tabs share.

import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import QRCreateHeaderBar from '../constant_components/header_bar';
import OverviewManager from './overview_manager';
import UsersManager from './users_manager';
import CodesManager from './codes_manager';
import ScansManager from './scans_manager';

export default function QRCreateDashboard() {
  const [activeTab, setActiveTab] = useState('overview');
  const [focusUserId, setFocusUserId] = useState(null);

  // Jump to the users tab with one account already open.
  const openUser = (userId) => {
    setFocusUserId(userId);
    setActiveTab('users');
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewManager />;
      case 'users':
        return <UsersManager focusUserId={focusUserId} onFocusHandled={() => setFocusUserId(null)} />;
      case 'codes':
        return <CodesManager onOpenUser={openUser} />;
      case 'scans':
        return <ScansManager onOpenUser={openUser} />;
      default:
        return <OverviewManager onOpenUser={openUser} />;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
      <QRCreateHeaderBar activeTab={activeTab} onTabChange={setActiveTab} />
      <main className="fade-in-enter-active">{renderContent()}</main>
    </div>
  );
}
